import { render, staticRenderFns } from "./PlanSection.vue?vue&type=template&id=80ef8ec4&"
import script from "./PlanSection.vue?vue&type=script&lang=ts&"
export * from "./PlanSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports